import { useConfigurableContext } from '@graphcommerce/magento-product-configurable';
import { Box, Button, CircularProgress } from '@mui/material'
import Link from 'next/link';
import { useContext, useEffect, useState } from 'react'
import TemplateContext from '../TemplateContext/template-context';
import { useCartIdCreate, useCurrentCartId } from '@graphcommerce/magento-cart';
import { useLazyQuery } from '@graphcommerce/graphql';
import { TemplatesDocument } from '../TemplateItems/gql/GetTemplates.gql';

function CustomizeButtonDirect(props) {
  const { sx, currentSku, disabled = false, tetherList, SkuOrganizer, by_use_id, product } = props;

  const configCtx = useConfigurableContext(currentSku);
  const { params, quantity } = useContext(TemplateContext);
  const { currentCartId } = useCurrentCartId();
  const create = useCartIdCreate();
  const [getTemplate, { loading, data, error }] = useLazyQuery(TemplatesDocument as any, { fetchPolicy: "no-cache" });
  const [template, setTemplate] = useState<any>();

  const sku = SkuOrganizer.find((o) => o.sku === product.url_key)
  const categoryId = sku ? sku.categoryId : 0;


  let variations: Array<any> = [];
  if (configCtx.variants[0]?.attributes) {
    variations = configCtx.variants[0]?.attributes;
  }

  let newObj = {};

  useEffect(() => {
    if (currentCartId === "") {
      create();
    }
  }, [currentCartId])

  useEffect(() => {
    if (variations) {
      for (let i = 0; i < variations.length; i++) {
        if (tetherList) {
          let newList = tetherList;
          for (let tether of newList) {
            if (variations[i].code == tether.uid) {
              if (newObj[variations[i].code]) {
                delete newObj[variations[i].code]
              }
              Object.assign(newObj, { [variations[i]?.code + "_val"]: { in: [variations[i]?.value_index?.toString()] } });
              break;
            } else {
              Object.assign(newObj, { [variations[i]?.code]: { in: [variations[i]?.value_index?.toString()] } });
            }
          }
        }
      }
    }
    getTemplate({ variables: { pageSize: params.templatesPerPage, currentPage: 1, filters: by_use_id ? { ...newObj, category_id: { in: [categoryId.toString()] }, shop_by_use_val: { in: [by_use_id.toString()] } } : { ...newObj, category_id: { in: [categoryId.toString()] }, } } });
  }, []);

  useEffect(() => {
    if (!loading && !error) {
      if (data) {
        setTemplate(data?.products?.items?.[0]);
      }
    }
  }, [loading, data, error])

  return (
    <>
      <Link href={currentCartId !== "" && template ? {
        pathname: "/editor/",
        query: {
          id: template?.template_content_id,
          prd: template?.product_id,
          attr: template?.attr_hash,
          crt: (currentCartId),
          qty: quantity
        }
      } : "#"} style={{ textDecoration: 'none' }}>
        <Button
          color='primary'
          variant='pill'
          size='large'
          disabled={disabled || !template}
          sx={sx}
        >
          {loading && <Box>
            <CircularProgress size='small' />
          </Box>}
          Customize
        </Button>
      </Link>
    </>
  )
}

export default CustomizeButtonDirect;
